export default __webpack_public_path__ + "static/media/service-thumb-concrete-driveway.f5666c60.jpg";